import rootReducer from './redux-saga/reducers/rootReducer';
import rootSagas from './redux-saga/sagas/rootSagas';

export default function getRootModule() {
  return {
    id: 'CLIENT',
    reducerMap: {
      CLIENT: rootReducer,
    },
    sagas: [rootSagas],
  };
}
